/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ResourceTimelineMessagesPageableResponseDto } from '../models';
// @ts-ignore
import type { ResourceTimelineMessagesSearchRequestDto } from '../models';
// @ts-ignore
import type { ResourceTypeDto } from '../models';
/**
 * RestResourcesTimelineMessagesApi - axios parameter creator
 */
export const RestResourcesTimelineMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ResourceTimelineMessagesSearchRequestDto} resourceTimelineMessagesSearchRequestDto Resources timeline messages search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesTimelineMessages: async (resourceId: string, resourceType: ResourceTypeDto, page: number, pageSize: number, resourceTimelineMessagesSearchRequestDto: ResourceTimelineMessagesSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getResourcesTimelineMessages', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getResourcesTimelineMessages', 'resourceType', resourceType)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getResourcesTimelineMessages', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getResourcesTimelineMessages', 'pageSize', pageSize)
            // verify required parameter 'resourceTimelineMessagesSearchRequestDto' is not null or undefined
            assertParamExists('getResourcesTimelineMessages', 'resourceTimelineMessagesSearchRequestDto', resourceTimelineMessagesSearchRequestDto)
            const localVarPath = `/api/resources/{resourceId}/timeline-messages-search`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourceTimelineMessagesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsSeen: async (resourceId: string, resourceType: ResourceTypeDto, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('markAsSeen', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('markAsSeen', 'resourceType', resourceType)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('markAsSeen', 'userId', userId)
            const localVarPath = `/api/resources/{resourceId}/timeline-messages/mark-as-seen`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestResourcesTimelineMessagesApi - functional programming interface
 */
export const RestResourcesTimelineMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestResourcesTimelineMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ResourceTimelineMessagesSearchRequestDto} resourceTimelineMessagesSearchRequestDto Resources timeline messages search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResourcesTimelineMessages(resourceId: string, resourceType: ResourceTypeDto, page: number, pageSize: number, resourceTimelineMessagesSearchRequestDto: ResourceTimelineMessagesSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceTimelineMessagesPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResourcesTimelineMessages(resourceId, resourceType, page, pageSize, resourceTimelineMessagesSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestResourcesTimelineMessagesApi.getResourcesTimelineMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsSeen(resourceId: string, resourceType: ResourceTypeDto, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsSeen(resourceId, resourceType, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestResourcesTimelineMessagesApi.markAsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestResourcesTimelineMessagesApi - factory interface
 */
export const RestResourcesTimelineMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestResourcesTimelineMessagesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ResourceTimelineMessagesSearchRequestDto} resourceTimelineMessagesSearchRequestDto Resources timeline messages search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesTimelineMessages(resourceId: string, resourceType: ResourceTypeDto, page: number, pageSize: number, resourceTimelineMessagesSearchRequestDto: ResourceTimelineMessagesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ResourceTimelineMessagesPageableResponseDto> {
            return localVarFp.getResourcesTimelineMessages(resourceId, resourceType, page, pageSize, resourceTimelineMessagesSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsSeen(resourceId: string, resourceType: ResourceTypeDto, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAsSeen(resourceId, resourceType, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestResourcesTimelineMessagesApi - interface
 */
export interface RestResourcesTimelineMessagesApiInterface {
    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ResourceTimelineMessagesSearchRequestDto} resourceTimelineMessagesSearchRequestDto Resources timeline messages search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResourcesTimelineMessages(resourceId: string, resourceType: ResourceTypeDto, page: number, pageSize: number, resourceTimelineMessagesSearchRequestDto: ResourceTimelineMessagesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ResourceTimelineMessagesPageableResponseDto>;

    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markAsSeen(resourceId: string, resourceType: ResourceTypeDto, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestResourcesTimelineMessagesApi - object-oriented interface
 */
export class RestResourcesTimelineMessagesApi extends BaseAPI implements RestResourcesTimelineMessagesApiInterface {
    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ResourceTimelineMessagesSearchRequestDto} resourceTimelineMessagesSearchRequestDto Resources timeline messages search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getResourcesTimelineMessages(resourceId: string, resourceType: ResourceTypeDto, page: number, pageSize: number, resourceTimelineMessagesSearchRequestDto: ResourceTimelineMessagesSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestResourcesTimelineMessagesApiFp(this.configuration).getResourcesTimelineMessages(resourceId, resourceType, page, pageSize, resourceTimelineMessagesSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markAsSeen(resourceId: string, resourceType: ResourceTypeDto, userId: string, options?: RawAxiosRequestConfig) {
        return RestResourcesTimelineMessagesApiFp(this.configuration).markAsSeen(resourceId, resourceType, userId, options).then((request) => request(this.axios, this.basePath));
    }
}

